import {
  DEFAULT_FOOD_DETAIL_NUTRIENTS,
  DEFAULT_FOOD_MAIN_NUTRIENTS,
  DEFAULT_SEARCH_MAIN_NUTRIENTS,
  OFF_NUTRIENT_METADATA,
} from './openFoodFactsNutrients';

export const DEFAULT_FOOD_MAIN_MACROS = DEFAULT_FOOD_MAIN_NUTRIENTS;

export const SUMMARY_ESSENTIAL_MACROS = Object.freeze([
  'proteins',
  'carbohydrates',
  'fat',
  'fiber',
  'sugars',
  'added-sugars',
  'sodium',
  'salt',
  'saturated-fat',
  'cholesterol',
]);

const SUMMARY_MACRO_BLACKLIST = new Set(['energy']);

export const DEFAULT_FOOD_DETAIL_MACROS = DEFAULT_FOOD_DETAIL_NUTRIENTS;

export const DEFAULT_SEARCH_MAIN_MACROS = DEFAULT_SEARCH_MAIN_NUTRIENTS;

export const AVAILABLE_MACROS = Object.freeze(
  OFF_NUTRIENT_METADATA
    .filter(({ key }) => !SUMMARY_MACRO_BLACKLIST.has(key))
    .map(({ key, label, unit }) => ({ key, label, unit }))
);

export const MACRO_ORDER = Object.freeze(AVAILABLE_MACROS.map((macro) => macro.key));

export const PREMIUM_ONLY_MACROS = Object.freeze([
  'trans-fat',
  'monounsaturated-fat',
  'polyunsaturated-fat',
  'vitamin-a',
  'vitamin-b1',
  'vitamin-b2',
  'vitamin-b6',
  'vitamin-b9',
  'vitamin-b12',
  'vitamin-c',
  'vitamin-d',
  'vitamin-e',
  'vitamin-k',
  'calcium',
  'iron',
  'magnesium',
  'zinc',
  'copper',
  'manganese',
  'phosphorus',
  'potassium',
  'selenium',
  'choline',
  'caffeine',
  'alcohol',
  'starch',
  'added-sugars',
]);
